import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import AllInventorySection from './AllInventorySection'
import InventoryListHeader from './InventoryListHeader'
import IndividualInventorySections from './IndividualInventorySections'

import {
  getGamInventoryType,
  inventoryTypes
} from '../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/helpers'
import { getAllocationInfo } from '../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { getUnitTypeLabel } from '../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/formatters/formatUnitType'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import {
  AD_INVENTORY,
  BILLING_EVENT
} from '../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const InventoryOverviewSection = () => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()

  const right = useSelector(rightSelector)
  const { isPercentageAllocation } = getAllocationInfo(right)
  const unitTypeLabel = getUnitTypeLabel(right[BILLING_EVENT])

  const inventoryType = getGamInventoryType(right[AD_INVENTORY])

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Inventory overview')}</h3>
      {isPercentageAllocation ? (
        <p>
          {t(
            `A summary of all the ${inventoryType === inventoryTypes.placements ? 'placements' : 'ad units'}, the percentages allocated to them in the right and the days remaining to create line items for.`
          )}
        </p>
      ) : (
        <p>
          {t(
            `A summary of all the ${inventoryType === inventoryTypes.placements ? 'placements' : 'ad units'}, the ${unitTypeLabel} allocated to them in the right and the ${unitTypeLabel} remaining.`
          )}
        </p>
      )}
      <InventoryListHeader />
      <AllInventorySection />
      <IndividualInventorySections />
    </section>
  )
}

export default InventoryOverviewSection
